enum MODAL_NAME {
    SHARE_PROPERTY,
    ADD_INCOME_TYPE
}

export default MODAL_NAME;
